import { FundingApplicationAppRouter } from "./routes";

export const FundingApplicationApp = () => {
  return <FundingApplicationAppRouter />;
};
